import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { SOLUTIONS, MODULES, IMAGES } from "../data/content";
import PageHero from "../components/PageHero";
import SectionHead from "../components/SectionHead";
import WorkflowSteps from "../components/WorkflowSteps";
import FlowChart from "../components/FlowChart";
import ProductImage from "../components/ProductImage";
import Icon from "../components/Icon";
import CtaBanner from "../components/CtaBanner";
import "../styles/solutionDetail.css";

const SLUG_ICON = {
  attendance: "attendance",
  "leave-permission": "leave",
  payroll: "payroll",
  "multi-branch": "branch",
  "admin-dashboard": "dashboard",
};

function SolutionDetail() {
  const { slug } = useParams();
  const solution = SOLUTIONS.find((s) => s.slug === slug);

  if (!solution) return <Navigate to="/solutions" replace />;

  const relatedModules = MODULES.filter((m) => solution.moduleIds.includes(m.id));
  const hasRealScreenshot = Boolean(solution.image && IMAGES[solution.image]);

  return (
    <>
      <PageHero eyebrow="Solutions" title={solution.name} subtitle={solution.description} />

      <section className="section">
        <div className="container product-visual-grid">
          {hasRealScreenshot ? (
            <ProductImage src={IMAGES[solution.image]} alt={`${solution.name} — Admin Dashboard`} frame="device" />
          ) : (
            <div className="solution-icon-panel">
              <span className="solution-icon-panel-icon">
                <Icon name={SLUG_ICON[solution.slug] || "product"} size={40} />
              </span>
              <span className="solution-icon-panel-label">{solution.name}</span>
            </div>
          )}
          <div>
            <SectionHead eyebrow="Related modules" title="What powers this solution" />
            <div className="related-modules-list">
              {relatedModules.map((mod) => (
                <div className="related-module-item" key={mod.id}>
                  <h4>{mod.name}</h4>
                  <p>{mod.detail}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {solution.workflowSteps && (
        <section className="section section--alt">
          <div className="container">
            <SectionHead eyebrow="Workflow" title="How it works" />
            <WorkflowSteps steps={solution.workflowSteps} />
            <FlowChart
              steps={solution.workflowSteps}
              icon={SLUG_ICON[solution.slug] || "workflow"}
              variant="solution-workflow-flowchart"
            />
          </div>
        </section>
      )}

      {solution.benefits && (
        <section className="section">
          <div className="container">
            <SectionHead eyebrow="Benefits" title="Why it matters" />
            <ul className="benefits-list">
              {solution.benefits.map((b) => (
                <li className="benefits-item" key={b}>
                  <span className="benefits-check" aria-hidden="true">
                    <Icon name="check" size={13} />
                  </span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}

      <section className="section section--alt">
        <div className="container">
          <Link to="/solutions" className="link-arrow">
            <Icon name="arrow" size={14} className="link-arrow-back" /> Back to all solutions
          </Link>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}

export default SolutionDetail;
